import React, {Component} from 'react'
import PropTypes from 'prop-types'

import Error from 'lib/struct/Error'

import styles from './Select.less'
import Cookies from "js-cookie";

const {
    'select': select_class,
    'select-20': select_20_class,
    'select-wrapper': select_wrapper_class,
    'select_invalid': invalid_select_class,
    'select-option_marked': marked_option_class,
} = styles

class Select extends Component {
    render() {
        const {className, wrapperClassName, emptyValueLabel, options, error, children, ...props} = this.props

        const select_classes = [];
        if(Cookies.get('force_set_wa_backend_ui_version') == 2) {
            select_classes.push(select_20_class)
        } else {
            select_classes.push(select_class)
        }
        if (className) {
            select_classes.push(className)
        }

        const wrapper_classes = [select_wrapper_class]
        if (wrapperClassName) {
            wrapper_classes.push(wrapperClassName)
        }

        if (error) {
            select_classes.push(invalid_select_class)
        }

        return (
            <div className={wrapper_classes.join(' ')}>
                <select className={select_classes.join(' ')} {...props}>
                    {
                        children ? (children) : (
                            options.map((option) => (
                                <option
                                    key={option.value}
                                    value={option.value}
                                    disabled={!!option.disabled}
                                    className={option.is_marked ? marked_option_class : ''}
                                >
                                    {!option.value && emptyValueLabel ? emptyValueLabel : option.label}
                                </option>
                            ))
                        )
                    }
                </select>

                <Error error={error}/>
            </div>
        )
    }
}

Select.propTypes = {
    options: PropTypes.arrayOf(PropTypes.shape({
        label: PropTypes.any,
        value: PropTypes.any
    })).isRequired
}

export default Select